import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getQueryKey } from '~/services'
import { resolveKey } from '~/services/preferences/preferences'
import {
  setWorkspacePreference,
  type SetWorkspacePreferencePropsUnion,
} from '~/services/preferences/workspacePreferences'

type Props = { onSuccess?: () => void } & SetWorkspacePreferencePropsUnion

export const useSetWorkspacePreferences = (workspaceId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ onSuccess: _onSuccess, ...props }: Props) => {
      return await setWorkspacePreference(props, workspaceId)
    },
    onSuccess: async (_, { onSuccess, ...props }: Props) => {
      const queryKey = getQueryKey('workspaces_/$workspaceId_/preferences/$path', {
        path: resolveKey(props),
        workspaceId,
      })
      queryClient.setQueryData(queryKey, props.value)
      queryClient.invalidateQueries({ queryKey })
      onSuccess?.()
    },
    onError: (error) => {
      console.error('Error updating user workspace preferences', error)
    },
  })
}
